<template>
  <b-container fluid>
    <div v-if="company !== 'Portal'">
      <b-row class="mt-3 d-none d-md-block">
        <b-col>
          <banner :country-code="user.countryCode" :company="company"></banner>
        </b-col>
      </b-row>
    </div>

    <b-row class="mt-3">
      <div class="alert alert-danger" v-if="revalidationStatus === 'RequiresRevalidation'" role="alert">
        <span>{{ $t('ml_113926') }}</span>
      </div>
    </b-row>

    <b-row class="mt-3">
      <b-col xs="8" lg="8">
        <welcome
          :company="company"
          :country="user.country"
          :premium="user.premium"
          :mobile="user.mobile"
          v-if="shipTos.length || hasMriApplication || hasN2MembraneSizing"
        ></welcome>
        <no-shiptos :company="company" v-if="shipTos.length === 0"></no-shiptos>
      </b-col>

      <b-col xs="4" lg="4">
        <contact-us :numbers="phoneNumbers" v-if="phoneNumbers.length"></contact-us>
        <pay-online v-if="hasInvoiceApplication && showPayOnline" class="mt-1"></pay-online>
      </b-col>
    </b-row>

    <div
      class="mt-3 bucketWrapper"
      :class="{ disabled: revalidationStatus === 'RequiresRevalidation' }"
      v-if="shipTos.length || hasMriApplication || hasN2MembraneSizing"
    >
      <template v-for="(bucket, index) in buckets">
        <bucket
          v-if="index < 6"
          :image="bucketImagePath(bucket.image)"
          :text="$t(bucket.stringId)"
          :url="bucket.link"
          :key="bucket.stringId"
        />
      </template>
    </div>
  </b-container>
</template>

<script>
import Banner from '@/components/Banner.vue'
import Bucket from '@/components/Bucket.vue'
import NoShiptos from '@/components/NoShiptos.vue'
import PayOnline from '@/components/PayOnline.vue'
import ContactUs from '@/components/ContactUs.vue'
import Welcome from '@/components/Welcome.vue'

export default {
  name: 'Home',
  components: {
    Banner,
    Bucket,
    NoShiptos,
    PayOnline,
    ContactUs,
    Welcome
  },
  data() {
    return {
      company: window.apci.getUserCompany(),
      buckets: [],
      phoneNumbers: {}
    }
  },
  computed: {    
    user() {
      return this.$store.state.user
    },
    shipTos() {
      return this.$store.state.shipTos
    },
    applications() {
      return this.$store.state.applications
    },
    showPayOnline() {
      return !['US', 'CA', 'BR', 'AR', 'CL', 'CO', 'EC', 'PE', 'AE', 'OM', 'TW', 'CN', 'KR', 'ID', 'MY', 'SG'].includes(
        this.user.countryCode
      )
    },
    hasMriApplication() {
      return this.$store.state.applications.some(a => a.applicationName === 'MRIKCP')
    },
    hasInvoiceApplication() {
      return this.$store.state.applications.some(a => a.applicationName === 'Invoice')
    },
    hasN2MembraneSizing() {
      return this.$store.state.applications.some(a => a.applicationName === 'N2MembraneSizing')
    },
    revalidationStatus() {
      return this.$store.state.revalidationStatus
    }
  },
  methods: {
    bucketImagePath(file) {
      return require(`@/assets/bucket_icons/${file}`)
    }
  },
  mounted() {
    let self = this

    this.$axios.get('/api/v1/navigation/buckets').then(success => {
      self.buckets = success.data
    })

    this.$axios.get('/api/v1/user/phonenumbers').then(success => {
      self.phoneNumbers = success.data
    })
  }
}
</script>

<style>
.bucketWrapper {
  display: grid;
  grid-template-columns: repeat(3, 270px);
}

@media (max-width: 1130px) {
  .bucketWrapper {
    display: grid;
    grid-template-columns: repeat(2, 270px);
  }
}

@media (max-width: 994px) {
  .bucketWrapper {
    display: grid;
    grid-template-columns: repeat(3, 270px);
  }
}

@media (max-width: 850px) {
  .bucketWrapper {
    display: grid;
    grid-template-columns: repeat(2, 270px);
  }
}

@media (max-width: 580px) {
  .bucketWrapper {
    display: grid;
    grid-template-columns: repeat(1, 270px);
  }
}
</style>
